var t={center:"center",top:"bottom",bottom:"top",left:"right",right:"left"};export{t as OppositeDirections};
